import { api } from './api';
import type { GeneratedVideo } from '../types';

export interface SlidePayload {
  image_path: string;
  duration_seconds?: number;
}

export interface GenerateVideoRequest {
  slides: SlidePayload[];
  music_id?: number;
  strategy_id?: number;
  generation_id?: number;
  caption?: string;
  resolution?: string;
}

export const videoApi = {
  generate: (body: GenerateVideoRequest) =>
    api.post<{ video_id: number; status: string }>('/videos/generate', body),

  generateFromCarousel: (generationId: number, musicId?: number) => {
    const q = musicId ? `?music_id=${musicId}` : '';
    return api.post<{ video_id: number; status: string }>(`/videos/from-carousel/${generationId}${q}`, {});
  },

  listVideos: (params: { strategy_id?: number; status?: string; limit?: number; offset?: number } = {}) => {
    const q = new URLSearchParams();
    if (params.strategy_id != null) q.set('strategy_id', String(params.strategy_id));
    if (params.status) q.set('status', params.status);
    if (params.limit != null) q.set('limit', String(params.limit));
    if (params.offset != null) q.set('offset', String(params.offset));
    return api.get<{ videos: GeneratedVideo[]; total: number }>(`/videos?${q}`);
  },

  getVideo: (id: number) =>
    api.get<GeneratedVideo>(`/videos/${id}`),

  deleteVideo: (id: number) =>
    api.delete<{ status: string }>(`/videos/${id}`),

  publishReel: (id: number, caption?: string) =>
    api.post<{ ig_media_id: string; permalink: string }>(`/videos/${id}/publish`, { caption }),

  getDownloadUrl: (id: number) =>
    `/api/videos/${id}/download`,
};
